<template>
  <div class="account-location">
    <el-page-header @back="$router.go(-1)" content="成果路演"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="路演模板" name="0">
        <Template />
      </el-tab-pane>
      <el-tab-pane label="路演报告" name="1">
        <MyRoadshow />
      </el-tab-pane>
      <el-tab-pane label="成果展示" name="2">
        <Result ref="Result" />
      </el-tab-pane>
      <el-tab-pane label="评价窗口" name="3" lazy>
        <Evaluate category="ly" />
      </el-tab-pane>
      <el-tab-pane label="英雄榜" name="4" lazy>
        <Ranking category="ly" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Evaluate from "../evaluate.vue";
import MyRoadshow from "./myRoadshow.vue";
import Ranking from "../ranking.vue";
import Result from "./result.vue";
import Template from './template.vue';

export default {
  components: { MyRoadshow, Evaluate, Ranking, Result, Template },
  data() {
    return {
      activeName: "0",
    };
  },
  watch: {
    activeName(val) {
      if (val == "2") this.$refs.Result.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.account-location {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>